<div *ngIf="cardDireito.parecer">
  <div class="sos-content">
    <h4>Parecer do SOS</h4>
  </div>
  <label class="info-parecer">{{ getParecerInfo() }}</label>
  <div class="desc-parecer"  [innerHTML]="getParecerDesc()"></div>

  <div *ngFor="let motivo of cardDireito?.motivosSos">
    <span class="item-motivo"> - {{ motivo }}</span>
  </div>
</div>
